import React from 'react';
import Downshift from 'downshift';

const Dashbox = ({ items, placeholder, className, type, onChange, value }) => {
    return (
      <Downshift
        itemToString={x => x}
        >
        {({
          getInputProps,
          getItemProps,
          isOpen,
          inputValue,
          selectedItem,
          highlightedIndex,
        }) => (
          <div className="auto">
            <input {...getInputProps({ placeholder, className, type, value })} autoFocus />
            {isOpen ? (
              <div className="suggest">
                {items
                  .filter(i => !inputValue || i.title.toLowerCase().includes(inputValue.toLowerCase()))
                  .map((item, index) => (
                    <div
                      {...getItemProps({
                        key: item.title,
                        index,
                        item,
                        style: {
                          backgroundColor: highlightedIndex === index
                            ? '#f9f9f9'
                            : 'white',
                          fontWeight: selectedItem === item.title
                            ? '600'
                            : 'normal',
                        },
                      })}
                      >
                      <a href={item.app_url} target="_blank" rel="noopener noreferrer">
                        <img src={item.icon} alt={item.title} />                     
                        <p>{item.title}</p>
                      </a>
                      
                    </div>
                  ))}
              </div>
            ) : null}
          </div>
        )}
      </Downshift>
    )
  }

  export default Dashbox;


// WEBPACK FOOTER //
// ./src/components/Dashbox.js